module.exports = __webpack_public_path__ + "static/media/codeforgood.0d43072a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/codeforgood.webp
// module id = 559
// module chunks = 0